export const REQUEST_DOWNLOAD_BEGIN = "REQUEST_DOWNLOAD_BEGIN";
export const REQUEST_DOWNLOAD_SUCCESS = "REQUEST_DOWNLOAD_SUCCESS";
export const REQUEST_DOWNLOAD_FAILURE = "REQUEST_DOWNLOAD_FAILURE";

export const REQUEST_DELETE_BEGIN = "REQUEST_DELETE_BEGIN";
export const REQUEST_DELETE_SUCCESS = "REQUEST_DELETE_SUCCESS";
export const REQUEST_DELETE_FAILURE = "REQUEST_DELETE_FAILURE";

export const DOWNLOAD_CATEGORIES_CHECKBOX_CHANGED = "DOWNLOAD_CATEGORIES_CHECKBOX_CHANGED";
export const DOWNLOAD_RADIO_CHANGED = "DOWNLOAD_RADIO_CHANGED";

export const DOWNLOAD_AMOUNT_CHANGED = "DOWNLOAD_AMOUNT_CHANGED";

export const CANCEL_DOWNLOAD_BEGIN = "CANCEL_DOWNLOAD_BEGIN";
export const CANCEL_DOWNLOAD_SUCCESS = "CANCEL_DOWNLOAD_SUCCESS";
export const CANCEL_DOWNLOAD_FAILURE = "CANCEL_DOWNLOAD_FAILURE";

export const CANCEL_DELETE_BEGIN = "CANCEL_DELETE_BEGIN";
export const CANCEL_DELETE_SUCCESS = "CANCEL_DELETE_SUCCESS";
export const CANCEL_DELETE_FAILURE = "CANCEL_DELETE_FAILURE";

export const FETCH_PAGE_CONTENT_BEGIN = "FETCH_PAGE_CONTENT_BEGIN";
export const FETCH_PAGE_CONTENT_SUCCESS = "FETCH_PAGE_CONTENT_SUCCESS";
export const FETCH_PAGE_CONTENT_FAILURE = "FETCH_PAGE_CONTENT_FAILURE";

export const FETCH_REQUEST_HISTORY_BEGIN = "FETCH_REQUEST_HISTORY_BEGIN";
export const FETCH_REQUEST_HISTORY_SUCCESS = "FETCH_REQUEST_HISTORY_SUCCESS";
export const FETCH_REQUEST_HISTORY_FAILURE = "FETCH_REQUEST_HISTORY_FAILURE";

export const SEND_SECURE_PIN_TO_DEVICE_BEGIN = "SEND_SECURE_PIN_TO_DEVICE_BEGIN";
export const SEND_SECURE_PIN_TO_DEVICE_SUCCESS = "SEND_SECURE_PIN_TO_DEVICE_SUCCESS";
export const SEND_SECURE_PIN_TO_DEVICE_FAILURE = "SEND_SECURE_PIN_TO_DEVICE_FAILURE";

export const VALIDATE_SECURE_PIN_BEGIN = "VALIDATE_SECURE_PIN_BEGIN";
export const VALIDATE_SECURE_PIN_SUCCESS = "VALIDATE_SECURE_PIN_SUCCESS";
export const VALIDATE_SECURE_PIN_FAILURE = "VALIDATE_SECURE_PIN_FAILURE";

export const GENERIC_ERROR_MESSAGE =
  "We're sorry but something went wrong while trying to process your request.";

export const HANDLE_FILE_AVAILABLE_CLICK = "HANDLE_FILE_AVAILABLE_CLICK";

export const AFFIDAVIT_CONSENT_BEGIN = "AFFIDAVIT_CONSENT_BEGIN";
export const AFFIDAVIT_CONSENT_SUCCESS = "AFFIDAVIT_CONSENT_SUCCESS";
export const AFFIDAVIT_CONSENT_FAILURE = "AFFIDAVIT_CONSENT_FAILURE";

export const RESET_DOWNLOAD_TYPE_TO_REGULAR = "RESET_DOWNLOAD_TYPE_TO_REGULAR";

export const SELECTED_DEVICE_CHANGED = "SELECTED_DEVICE_CHANGED";

export const DELETE_LINE_SELECTION_RADIO_CHANGED = "DELETE_LINE_SELECTION_RADIO_CHANGED";

export const RESET_CANCEL_DOWNLOAD_TYPE = "RESET_CANCEL_DOWNLOAD_TYPE";

export const CLEAR_ERRORS = "CLEAR_ERRORS";

export const CHECK_IF_MDN_SMS_CAPABLE_BEGIN = "CHECK_IF_MDN_SMS_CAPABLE_BEGIN";
export const CHECK_IF_MDN_SMS_CAPABLE_SUCCESS = "CHECK_IF_MDN_SMS_CAPABLE_SUCCESS";
export const CHECK_IF_MDN_SMS_CAPABLE_FAILURE = "CHECK_IF_MDN_SMS_CAPABLE_FAILURE";

export const FETCH_PROFILE_API_BEGIN = "FETCH_PROFILE_API_BEGIN";
export const FETCH_PROFILE_API_SUCCESS = "FETCH_PROFILE_API_SUCCESS";
export const FETCH_PROFILE_API_FAILURE = "FETCH_PROFILE_API_FAILURE";

export const FETCH_MARKETING_PREFERENCES_BEGIN = "FETCH_MARKETING_PREFERENCES_BEGIN";
export const FETCH_MARKETING_PREFERENCES_SUCCESS = "FETCH_MARKETING_PREFERENCES_SUCCESS";
export const FETCH_MARKETING_PREFERENCES_FAILURE = "FETCH_MARKETING_PREFERENCES_FAILURE";

export const SET_MARKETING_PREFERENCES_BEGIN = "SET_MARKETING_PREFERENCES_BEGIN";
export const SET_MARKETING_PREFERENCES_SUCCESS = "SET_MARKETING_PREFERENCES_SUCCESS";
export const SET_MARKETING_PREFERENCES_FAILURE = "SET_MARKETING_PREFERENCES_FAILURE";

export const RESEND_PASSWORD_BEGIN = "RESEND_PASSWORD_BEGIN";
export const RESEND_PASSWORD_SUCCESS = "RESEND_PASSWORD_SUCCESS";
export const RESEND_PASSWORD_FAILURE = "RESEND_PASSWORD_FAILURE";

export const HANDLE_MARKETING_PREFERENCES_CHANGE = "HANDLE_MARKETING_PREFERENCES_CHANGE";

export const RESET_PROGRESS_INDICATOR_LIST = "RESET_PROGRESS_INDICATOR_LIST";

export const SET_BREADCRUMB_LIST_IN_REDUX = "SET_BREADCRUMB_LIST_IN_REDUX";

export const CUSTOM_DATE_RANGE_CHANGED = "CUSTOM_DATE_RANGE_CHANGED";
